<app-snapshot-list></app-snapshot-list>

<vi-loader
  *ngIf="remoteDiagnosticsSnapshotsStore.showFetchSnapshotDetailsLoader$ | async; else backupTable"
  [isLoading]="true"
  message="{{ '+REMOTE_DIAGNOSTICS_SNAPSHOTS.LOADER.FETCHING_SNAPSHOT_DETAILS_TEXT' | translate }}"
></vi-loader>

<ng-template #backupTable>
  <ng-container *ngIf="remoteDiagnosticsSnapshotsStore.snapshotDetails$ | async as vdds">
    <ng-container *ngIf="vdds?.length; else snapshotNotYetReady">
      <app-backup-vdd-table
        [snapshotType]="snapshotType.SNAPSHOT"
        [vdds]="vdds"
      ></app-backup-vdd-table>
    </ng-container>
    <ng-template #snapshotNotYetReady>
      <vi-loader
        *ngIf="remoteDiagnosticsSnapshotsStore.selectedSnapshot$ | async"
        [isLoading]="true"
        message="{{
          '+REMOTE_DIAGNOSTICS_SNAPSHOTS.LOADER.FETCHING_SNAPSHOT_DETAILS_TEXT' | translate
        }}"
      ></vi-loader>
    </ng-template>
  </ng-container>
</ng-template>
